import PageAdress from "../../components/pageAdress/pageAdress";
import ProfileCom from "../../components/profile/profileCom";
import "./profile.css"

function Profile(){
    return(
        <div className="profile">
            <div className="profile-container">
                <PageAdress data={"حساب کاربری"}/>
                <ProfileCom/>
            </div>
        </div>
    )
}

export default Profile;